import React, { useState } from 'react';
import axios from 'axios';
import { ShieldCheck } from 'lucide-react';
import { API, authHeaders, fmtErr, fmtDate } from '../../lib/auth';

export const SettingsTab = ({ me, setMe, flash }) => {
  const [pName, setPName] = useState(me.name || '');
  const [pPhone, setPPhone] = useState(me.phone || '');
  const [curPw, setCurPw] = useState('');
  const [newPw, setNewPw] = useState('');

  const saveProfile = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.patch(`${API}/user/profile`, { name: pName, phone: pPhone }, { headers: authHeaders() });
      setMe(data); flash('Account details updated');
    } catch (err) { flash(fmtErr(err.response?.data?.detail)); }
  };

  const changePw = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/user/change-password`, { current_password: curPw, new_password: newPw }, { headers: authHeaders() });
      setCurPw(''); setNewPw(''); flash('Password changed');
    } catch (err) { flash(fmtErr(err.response?.data?.detail)); }
  };

  return (
    <div className="dash-card" data-testid="settings-section">
      <h3>Account Settings</h3>
      <div className="detail-grid2" style={{ marginBottom: 18 }}>
        <div className="detail-item"><span className="dlabel">Krysha ID</span><span className="dval">{me.krysha_id}</span></div>
        <div className="detail-item"><span className="dlabel">Email</span><span className="dval">{me.email}</span></div>
        <div className="detail-item"><span className="dlabel">Profile Visibility</span><span className="dval">{me.profile_live ? 'Live on Krysha' : 'Private'}</span></div>
        <div className="detail-item"><span className="dlabel">Member Since</span><span className="dval">{fmtDate(me.created_at)}</span></div>
      </div>
      <form onSubmit={saveProfile} className="settings-form">
        <label>Name</label>
        <input value={pName} onChange={(e) => setPName(e.target.value)} data-testid="settings-name-input" />
        <label>Mobile / WhatsApp (private)</label>
        <input value={pPhone} onChange={(e) => setPPhone(e.target.value)} data-testid="settings-phone-input" />
        <button className="btn btn-red btn-sm" type="submit" data-testid="settings-save-btn">Save Details</button>
      </form>
      <h3 style={{ marginTop: 24 }}>Change Password</h3>
      <form onSubmit={changePw} className="settings-form">
        <label>Current Password</label>
        <input type="password" value={curPw} onChange={(e) => setCurPw(e.target.value)} required data-testid="settings-curpw-input" />
        <label>New Password</label>
        <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} required minLength={6} data-testid="settings-newpw-input" />
        <button className="btn btn-ghost btn-sm" type="submit" data-testid="settings-changepw-btn">Change Password</button>
      </form>
      <p className="dash-privacy"><ShieldCheck size={13} /> Your email and mobile number stay private and are never shown on the Connect page.</p>
    </div>
  );
};

export default SettingsTab;
